import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';
import { history } from 'store';

class LoginForm extends Component {
  static propTypes = {
    email: PropTypes.string,
    viewStep: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
      error: ""
    }
  }

  handleFieldChange = e => this.setState({ [e.target.name]: e.target.value });

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.handleSubmit(e)
    }
  }

  handleGoogleResponse = resp => {
    this.props.loginUser({provider: 'google', code: resp.code}).then( resp => {
      if (resp) {
        this.setState({ error: "" });
        this.props.hideModal();
        history.push('/dashboard');
      } else {
        this.setState({ error: "An error ocurred, we should probably handle this better." });
      }
    });
  };

  handleFacebookResponse = resp => {
    this.props.loginUser({provider: 'facebook', code: resp.accessToken}).then( resp => {
      if (resp) {
        this.setState({ error: "" });
        this.props.hideModal();
        history.push('/dashboard');
      } else {
        this.setState({ error: "An error ocurred, we should probably handle this better." });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.verifyEmail(this.state.email).then(resp => {
      resp ? this.props.viewStep(2) : this.props.openModal('register', 1, false);
    });
  }

  render() {
    return (
      <form> 
        <TextField style={{marginBottom: '16px'}}
          type="email"
          name="email"
          label="Email"
          value={this.state.email} 
          onChange={this.handleFieldChange}
          fullWidth
          onKeyDown={this.handleKeyDown.bind(this)}
          margin="normal"
        />

        <Button variant="raised" color="primary" onClick={(e) => this.handleSubmit(e)} style={{width: '100%'}}>Submit</Button>
        <Divider light style={{margin: '8px 0px'}}/>

        <GoogleLogin
          clientId={process.env.GOOGLE_LOGIN_CLIENT_ID}
          buttonText="Login with Google"
          responseType="code"
          onSuccess={(resp) => this.handleGoogleResponse(resp)}
          onFailure={(resp) => this.handleGoogleResponse(resp)}
        />
        <div style={{margin: '8px 0px'}} />
        <FacebookLogin
          appId={process.env.FACEBOOK_LOGIN_APP_ID}
          autoLoad={false}
          fields="name,email,picture"
          scope="public_profile,email"
          callback={(resp) => this.handleFacebookResponse(resp)}
        />
      </form>
    );
  }
};

export default LoginForm;


// WEBPACK FOOTER //
// ./routes/Modal/Login/components/LoginForm/index.jsx